import {
  ILibraryManifestContext,
  IHostManifest,
  ILibraryTopology,
} from '../../registry.types';

import { createHostManifestBuilder } from './hostManifestBuilder';

export function createLibraryManifestBuilder({
  topology,
}: {
  topology: ILibraryTopology;
}) {
  const manifest: ILibraryManifestContext = {
    hosts: {},
    assets: [],
    statics: {},
    library: {
      url: topology.url,
      artifactId: topology.artifactId,
      namespace: topology.namespace,
      environment: {},
    },
  };

  const hostBuilders: Record<
    string,
    ReturnType<typeof createHostManifestBuilder>
  > = {};

  return {
    isHostExist(host: string) {
      return !!manifest.hosts[host];
    },

    getHostBuilder(host: string) {
      if (!hostBuilders[host]) {
        hostBuilders[host] = createHostManifestBuilder({ host });
      }

      return hostBuilders[host];
    },
    addHotBundle(url: string) {
      manifest.library.environment.hot = url;
      this.addLibraryAsset(url, 'hot', 'js');

      return this;
    },
    addWebpackRuntimeBundle(url: string) {
      manifest.library.environment.runtime = url;
      this.addLibraryAsset(url, 'webpack-runtime', 'js');

      return this;
    },

    addLibraryAsset(url: string, type: string, extension: string = 'unknown') {
      manifest.assets.push({ type, extension, url });

      return this;
    },

    addLibraryStatics(statics: Record<string, any>) {
      manifest.statics = statics;

      return this;
    },

    build(): ILibraryManifestContext {
      const hosts: Record<string, IHostManifest> = {};

      Object.keys(hostBuilders).forEach(host => {
        hosts[host] = hostBuilders[host].build();
      });

      return {
        ...manifest,
        hosts,
      };
    },
  };
}
